// libraries and utilities
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { apiGet, BASE_URL, retrieveToken } from "../../store/api";
import { JenisLembagaListResponse } from "./types";

import * as jenisLembagaActions from "./jenisLembaga.actions";

export function* getJenisLembaga(
  action: ReturnType<typeof jenisLembagaActions.getJenisLembagaAsync.request>
) {
  try {
    const token: string = yield retrieveToken();
    const url = BASE_URL + 'jenis-lembaga';
    const result: Response = yield call(apiGet, url, token);

    if (result.status === 200) {
      const parsed: JenisLembagaListResponse = yield call(result.json.bind(result));
      yield put(jenisLembagaActions.getJenisLembagaAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(jenisLembagaActions.getJenisLembagaAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(jenisLembagaActions.getJenisLembagaAsync.failure(parsed));
  }
}

export default function* jenisLembagaSagaGetJenisLembaga() {
  yield takeEvery(jenisLembagaActions.getJenisLembagaAsync.request, getJenisLembaga);
}
